import React from 'react'
import { useHistory } from 'react-router-dom'
import PersonOutlineOutlinedIcon from 'components/material-symbol/icons/PersonOutline'
import SectionEmptyState from 'components/section-empty-state'
import { TonalButton } from 'components/empty-page-state'
import { gtmEvent } from 'lib/gtm'

const CoachProfileEmptyState = () => {
  const history = useHistory()

  const redirectToCreateProfile = () => {
    history.push('/pga-coach/profile/new')
    gtmEvent({
      event: 'formSubmit',
      formCategory: 'coach-profile',
      formAction: 'clicked-create-coach-profile-button',
    })
  }

  return (
    <SectionEmptyState
      Icon={PersonOutlineOutlinedIcon}
      title="Coach Profile"
      caption="Your PGA Coach Profile will appear here once completed."
      bordered={false}
      action={
        <TonalButton onClick={redirectToCreateProfile}>
          Create Coach Profile
        </TonalButton>
      }
    />
  )
}

export default CoachProfileEmptyState
